import { useCallback } from 'react'
import { toast } from 'react-toastify'
import { proceedToNextStep } from 'src/services/receivement/receivementService'
import { useRouteToReceivement } from './useRouteToReceivement'

interface Props {
  supervisorBadge: string
  receivementId: number | string
  errorMessage: string
}

export const useRouteToNextStep = ({
  supervisorBadge,
  receivementId,
  errorMessage,
}: Props) => {
  const { routeToReceivement } = useRouteToReceivement()
  const routeToNext = useCallback(async () => {
    const result = await proceedToNextStep(supervisorBadge, receivementId)
    if (!result.isOk) {
      toast.error(errorMessage)
      return
    }
    routeToReceivement({
      receivementId,
      receivementStatus: result.data.status,
    })
  }, [errorMessage, receivementId, routeToReceivement, supervisorBadge])

  return {
    routeToNext,
  }
}
